import { useCallback, useMemo } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { activityListSelectionsAtom, setActivityListSelectionAtom } from '@store';

type UseLastSelectedActivityParams = {
    userId?: string;
};

export function useLastSelectedActivity({ userId }: UseLastSelectedActivityParams) {
    const activityListSelections = useAtomValue(activityListSelectionsAtom);
    const setActivityListSelection = useSetAtom(setActivityListSelectionAtom);

    const contextKey = useMemo(() => userId ?? '', [userId]);

    const lastSelectedActivityId = activityListSelections[contextKey] ?? null;

    const persistLastSelectedActivityId = useCallback(
        (activityId: number) => {
            setActivityListSelection({ contextKey, activityId });
        },
        [contextKey, setActivityListSelection],
    );

    return {
        lastSelectedActivityId,
        persistLastSelectedActivityId,
    };
}
